import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExamVoucher } from '../models/exam-voucher';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { environment } from '../../../environments/environment';
import { RouterParamsService } from '../../shared/services/router-params.service';

@Injectable({
  providedIn: 'root',
})
export class ExamVouchersEntityService extends BaseEntityService<ExamVoucher> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, {
        singular: 'examVoucher',
        plural: 'examVouchers',
        url: 'exam-vouchers',
      },
      routerParamsService,
      // No permissions yet: the API spec does not define the EXAM_VOUCHER_* names
    );
    this.nameId = 'examVoucherId';
  }
}
